export default __webpack_public_path__ + "static/media/link.e1f9c5f9.svg";